import React, { useState } from 'react';
// @ts-ignore
import styles from './WorkplaceWorkerSUKLLogin.module.scss';
import { Theme } from '../../../../../Enums/Theme.enum';
import Button from '../../../../../Components/Button/Button';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { saveToUserMeta } from '../../../../User/Services/userMeta.service';
import { Meta, useLazyUserMetaQuery } from '../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../helpers';
import { MetaKey } from '../../../../Meta/Enums/MetaKey.enum';
import { findInMeta } from '../../../../Meta/Services/meta.service';

interface Props {
	userId: string;
}

const validationSchema = yup.object({
	uuid: yup.string().notRequired(),
});

const WorkplaceWorkerSUKLLogin: React.FC<Props> = ({ userId }) => {
	const [isEditMode, setIsEditMode] = useState(false);
	const [SUKLLogin, setSUKLLogin] = useState<string | undefined>(undefined);
	const [getUserMeta] = useLazyUserMetaQuery();

	const loadData = async () => {
		const data = await getUserMeta({
			id: userId,
			useOriginalId: true,
		}).unwrap();
		const SUKLLogin = findInMeta({
			meta: data?.user?.meta as Meta[],
			metaKey: MetaKey.SUKL_LOGIN,
		});
		if (SUKLLogin?.value) {
			setSUKLLogin(SUKLLogin.value);
			formMethods.reset({ uuid: SUKLLogin.value });
		} else {
			setSUKLLogin('');
		}
	};

	useEffectAsync(async () => {
		await loadData();
	}, []);

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: any) => {
		await saveToUserMeta({
			userId: userId,
			key: MetaKey.SUKL_LOGIN,
			value: values.uuid,
		});
		await loadData();
		setIsEditMode(false);
	};

	if (isEditMode) {
		return (
			<FormWrapper formMethods={formMethods}>
				<InputField
					name='uuid'
					label='base.shared.uuid'
					className='mb-3'
					isRequired
				/>
				<SubmitButton onSubmit={handleSubmit} title='base.shared.save' />
			</FormWrapper>
		);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.item}>
				<div>UUID</div>
				<div>
					<span>{SUKLLogin}</span>
				</div>
			</div>
			<Button
				theme={Theme.GREEN}
				title='base.shared.edit'
				className={styles.button}
				onClick={() => setIsEditMode(true)}
			/>
		</div>
	);
};

export default WorkplaceWorkerSUKLLogin;
